import { AvatarDropdown, AvatarName, Footer,CustomSelectLang,ActionButton} from '@/components';
import { queryCurrentUser } from '@/services/userApi';
import { LinkOutlined } from '@ant-design/icons';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { SettingDrawer } from '@ant-design/pro-components';
import { history, Link } from '@umijs/max';
import React, {useEffect} from 'react';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';
import {setAuth,getAuth} from "@/utils/db";
// @ts-ignore
import {requestConfig} from '@/utils/request.js'
import useFormattedMessage from '@/hooks/useFormattedMessage'
import HeaderMenu from '@/components/HeaderDropdown'
import {initFacebookPixel} from "@/services/facebookPixel";


const isDev = process.env.NODE_ENV === 'development';
const accountPath = '/account';


export function rootContainer(container: React.ReactNode) {
  // 只在客户端初始化
  if (typeof document !== 'undefined') {
    initFacebookPixel().then((success) => {
      if (success) {
        console.log('Facebook Pixel initialized successfully');
      }
    });
  }
  return container;
}
/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      const res = await queryCurrentUser();
      return res.data;
    } catch (error) {
      //history.push(loginPath);
    }
    return undefined;
  };
  // 如果不是登录页面，执行
  const { location } = history;
  const token= getAuth()
   if(token){
     const currentUser = await fetchUserInfo();
     return {
       fetchUserInfo,
       currentUser:{...currentUser,name:currentUser.user_name},
       settings: defaultSettings as Partial<LayoutSettings>,
     };
   }
  return {
    fetchUserInfo,
    currentUser:{},
    settings: defaultSettings as Partial<LayoutSettings>,
  };

}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: ({initialState, setInitialState}: { initialState: any; setInitialState: any }) => {
  layout: string;
  actionsRender: () => React.JSX.Element[];
  childrenRender: (children: any) => React.JSX.Element;
  bgLayoutImgList: any[];
  footerRender: () => React.JSX.Element;
  patchMenus:() => void;
  onPageChange: () => void;
  links: React.JSX.Element[];
  title: string;
  menu: { mode: string };
  avatarProps: { src: string | undefined; title: React.JSX.Element;
    render: (_: any, avatarChildren: any) => React.JSX.Element };
  breadcrumbRender: boolean
} = ({ initialState, setInitialState }) => {
  const {formatterMessage} = useFormattedMessage()
  // 在线客服
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//fw-cdn.com/14566587/6247753.js';
    script.setAttribute('chat', 'true');
    script.async = true;

    // 添加到body
    document.body.appendChild(script);

    // 清理函数
    return () => {
      // 如果需要移除脚本，可以在这里处理
      document.body.removeChild(script);
    };

  }, []);
  return {
    ...initialState?.settings,
    logo:'/logo.png',
    title:'Findtrader',
    menuHeaderRender:undefined,
    menu: {
      mode: 'horizontal', // 强制菜单水平显示，
    },
    layout: 'top', // 关键：设置为顶部导航
    breadcrumbRender: false, // 完全关闭面包屑
    actionsRender: () =>{
      const userAction =   initialState?.currentUser?.name ? '':[<ActionButton  url='/user/login' formatId='menu.login' />,<ActionButton url='/user/register' formatId='menu.register' />]
      return [<CustomSelectLang key="SelectLang" />,...userAction]
    } ,
    avatarProps:initialState?.currentUser && {
      children: initialState?.currentUser?.name?.slice(0, 2) || initialState?.currentUser?.email?.slice(0, 2),
      style: {
        backgroundColor: '#8c52ff',
        color: '#fff',
      },
      title: <AvatarName/>,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },

    footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      if(location.pathname.includes('/account/')){
        // $('.ant-pro-top-nav-header-menu').hide()
        // 如果没有登录，重定向到 login
        if (!initialState?.currentUser?.name) {
           history.push('/user/login');
        }
      }
    },
    bgLayoutImgList: [],
    links: isDev
      ? [
          <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
            <LinkOutlined />
            <span>OpenAPI 文档</span>
          </Link>,
        ]
      : [],
    // menuHeaderRender: ()=><HeaderMenu />,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState: any) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )}
        </>
      );
    },

  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...errorConfig,
  ...requestConfig
};
